import { FC } from "react";
import { Button, Space } from "antd";
import { NavLink } from "react-router-dom";
import { ROUTES } from "@/consts";

const TiersTabButtons: FC = () => (
	<Space size={25} style={{ marginBottom: 20 }}>
		<NavLink to={ROUTES.Tiers} end>
			{({ isActive }) => (
				<Button
					shape="round"
					size="large"
					style={{
						backgroundColor: isActive ? "#4A90E2" : "#979797",
						color: "#fff",
					}}
				>
					Tiers
				</Button>
			)}
		</NavLink>
		<NavLink to={ROUTES.Vouchers} end>
			{({ isActive }) => (
				<Button
					shape="round"
					size="large"
					style={{
						backgroundColor: isActive ? "#4A90E2" : "#979797",
						color: "#fff",
					}}
				>
					Vouchers
				</Button>
			)}
		</NavLink>
	</Space>
);

export default TiersTabButtons;
